<template>
  <div class="flex flex-col gap-4">
    <!-- PRO-740: cards, chips and the "more" button are chat-only; an email answer lists the products as text -->
    <template v-if="!isEmailBot">
      <div>
        <base-label id="productLayout" :label="LAYOUT.label" :tooltip="LAYOUT.tooltip"/>
        <base-select :variant="isDisabled ? 'baseSelectDisabled' : 'baseSelect'"
                     :value="selectedLayoutText"
                     :options="layoutOptions"
                     class="mt-1 h-10"
                     :is-disabled="isDisabled"
                     @input="updateLayout"
        />
        <span v-if="!config.layout" class="block mt-1 text-xs text-gray">
          Automatic picks per answer: one product as a hero, a grid when the customer asks what something looks like, rows otherwise.
        </span>
      </div>

      <vx-tooltip :text="QUICK_FILTERS.tooltip" position="top" class="flex items-center">
        <checkbox id="productQuickFilters"
                  :is-checked="config.quickFilters"
                  :is-disabled="isDisabled"
                  @update:isChecked="update('quickFilters', $event)"
        />
        <label for="productQuickFilters"
               class="ml-2 text-gray-dark leading-tight"
               :class="isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'"
        >
          {{ QUICK_FILTERS.label }}
        </label>
      </vx-tooltip>

      <vx-tooltip :text="SHOW_CONTINUE.tooltip" position="top" class="flex items-center">
        <checkbox id="productShowContinue"
                  :is-checked="config.showContinue"
                  :is-disabled="isDisabled"
                  @update:isChecked="update('showContinue', $event)"
        />
        <label for="productShowContinue"
               class="ml-2 text-gray-dark leading-tight"
               :class="isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'"
        >
          {{ SHOW_CONTINUE.label }}
        </label>
      </vx-tooltip>
    </template>
  </div>
</template>

<script>
import Checkbox from '@/components/preview/Checkbox'
import conversationModule from '@/store/modules/conversation.module'
import {
  PRODUCT_RECOMMENDATION_DEFAULTS, PRODUCT_RECOMMENDATION_FIELDS, PRODUCT_LAYOUT_OPTIONS
} from '@/constants/product-recommendation.constants'

export default {
  name: 'ChatGPTEditorProductRecommendation',

  components: { Checkbox },

  props: {
    action: {
      type: Object,
      required: true
    },
    actionId: {
      type: String,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isEmailBot: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      ...PRODUCT_RECOMMENDATION_FIELDS,
      layoutOptions: PRODUCT_LAYOUT_OPTIONS.map(option => option.text)
    }
  },

  computed: {
    // Every key present whatever the saved action carries: actions authored before this section exists have
    // no `productRecommendation` at all, and the engine reads an absent key as these same defaults.
    config() {
      return { ...PRODUCT_RECOMMENDATION_DEFAULTS, ...(this.action.productRecommendation || {}) }
    },

    selectedLayoutText() {
      const option = PRODUCT_LAYOUT_OPTIONS.find(item => item.value === this.config.layout)
      return (option || PRODUCT_LAYOUT_OPTIONS[0]).text
    }
  },

  methods: {
    update(key, value) {
      if (this.isDisabled) return

      // PRO-740: the action type is the switch now — this section is always on for a product answer
      const productRecommendation = { ...this.config, [key]: value, enabled: true }
      conversationModule.updateChatGPTAction(this.actionId, { ...this.action, productRecommendation })
    },

    updateLayout(text) {
      const option = PRODUCT_LAYOUT_OPTIONS.find(item => item.text === text)
      if (option) this.update('layout', option.value)
    }
  }
}
</script>
